const baseStyle = {
  _hover: {
    textDecoration: "none"
  }
}

const sizes = {
  "navbar-main": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: { base: "16px !important", bd3: "22px !important" },
    letterSpacing: "0px",
    m: "0",
    p: "4px 0",
    color: "white !important",
    borderRadius: "0",
    outline: "none !important",
    textTransform: "none",
    backgroundColor: "transparent !important",
    borderColor: "transparent !important",
    borderTopWidth: "0px !important",
    borderLeftWidth: "0px !important",
    borderRightWidth: "0px !important",
    borderBottomWidth:"5px !important",
    transition:"all .2s ease-out",
    _hover:{
      color: "#FFF !important",
      borderColor: "#FFF !important",
      borderStyle: "solid !important",
      backgroundColor: "transparent !important",
    },
    _focus:{
      outline: "none !important",
      borderColor: "#FFF !important",
      borderStyle: "solid !important",
    },
    _focusVisible:{
      boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    }
  }
}

export const Link = {
  baseStyle,
  sizes,
}
